import { invokeApiGateway } from '../../auth/api-client';

export type HealthStatus = 'healthy' | 'degraded' | 'unhealthy';

export interface ServiceHealth {
  service: string;
  icon: string;
  status: HealthStatus;
  metric: string;
  metricValue: string;
  lastCheck: string;
}

export async function getHealth(env: string) {
  return invokeApiGateway(`/debug/health?env=${env.toLowerCase()}`);
}

export async function fetchHealthData(env: string): Promise<ServiceHealth[]> {
  const data = await getHealth(env);
  const services: ServiceHealth[] = [];

  if (data.sqs) {
    const dlqCount = data.sqs.dlq?.messages || 0;
    services.push({
      service: 'SQS Queues',
      status: dlqCount > 0 ? 'degraded' : 'healthy',
      metric: 'DLQ Messages',
      metricValue: `${dlqCount}`,
      icon: '📨',
      lastCheck: new Date().toISOString(),
    });
  }

  if (data.lambdas) {
    for (const [name, metrics] of Object.entries(data.lambdas as Record<string, any>)) {
      const errors = metrics.errors || 0;
      services.push({
        service: name.replace('AAGAgents-Beta-NA-', '').replace('AAGAgents-Prod-NA-', ''),
        status: errors > 0 ? 'degraded' : 'healthy',
        metric: 'Errors / P99',
        metricValue: `${errors} / ${Math.round(metrics.p99Duration || 0)}ms`,
        icon: 'λ',
        lastCheck: new Date().toISOString(),
      });
    }
  }

  if (data.cadenceRule) {
    services.push({
      service: 'EventBridge Cadence',
      status: data.cadenceRule.state === 'ENABLED' ? 'healthy' : 'unhealthy',
      metric: 'State',
      metricValue: data.cadenceRule.state || 'UNKNOWN',
      icon: '⏰',
      lastCheck: new Date().toISOString(),
    });
  }

  return services;
}